import React from 'react';
import { Link } from 'react-router-dom';

const TouristGuidesCourses = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-200 via-teal-200 to-cyan-300 flex flex-col items-center justify-center">
      <h1 className="text-5xl font-extrabold text-gray-800 mb-8">دورات وتدريب المرشدين السياحيين</h1>
      <div className="w-full md:w-2/3 lg:w-1/2 p-8 bg-white rounded-lg shadow-xl">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">كن مرشدًا سياحيًا معتمدًا</h2>
        <p className="text-gray-600 mb-4">تم تصميم دوراتنا لتدريب الأفراد الذين يشعرون بالشغف بمشاركة معرفتهم بالتاريخ والثقافة والطبيعة. مع شهادتنا، يمكنك بدء مسيرة مهنية مجزية كمرشد سياحي محترف.</p>
        <Link to='/tourist-guides' className="inline-block bg-cyan-500 text-white py-2 px-4 rounded hover:bg-cyan-600 transition">
          انضم لدورتنا
        </Link>
      </div>
    </div>
  );
};

export default TouristGuidesCourses;
